import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'Douleutaras/components/Modal/Modal';

import './StepsModal.scss';

interface StepsModalProps {
  isOpen: boolean;
  showBackBtn?: boolean;
  children?: React.ReactNode;
  dismissCallback?(): void;
  backCallback?(): void;
}

export const StepsModal = ({ children, dismissCallback, isOpen, backCallback, showBackBtn = false }: StepsModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} dismissCallback={dismissCallback}>
      <article styleName="steps-modal">
        <div styleName="steps-modal-grid">
          { showBackBtn &&
          <section styleName="steps-modal-prev">
            <button onClick={() => backCallback()} styleName="steps-modal-prev__btn" type="button" >
              {t('T.CD.POPUP.BACK')}
            </button>
          </section>
          }
          <section styleName="steps-modal-close">
            <button styleName="steps-modal-close__btn"
                    type="button"
                    aria-label={t('T.CD.POPUP.CLOSE-MODAL')}
                    data-testid={999999}
                    onClick={dismissCallback} />
          </section>
          <section styleName="steps-modal-content-wrapper">
            <div styleName="steps-modal-content">
              {children}
            </div>
          </section>
          <section styleName="steps-modal-background">
            <svg viewBox="0 0 367 577" preserveAspectRatio="none">
              <defs>
                <linearGradient id="popup-linear-gradient" x1="183.448" y1="0" x2="183.448" y2="577" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#383865" />
                  <stop offset="0.713542" stopColor="#2A2D76" />
                  <stop offset="1" stopColor="#212486" />
                </linearGradient>
              </defs>
              <path fillRule="evenodd" clipRule="evenodd" d="M365.806 0L16 0C7.16344 0 0 7.16344 0 16V561C0 569.837 7.16344 577 16 577H296.16C328.857 550.243 354.52 515.614 364.303 470.988C374.716 423.491 351.93 376.119 328.591 327.597C312.228 293.577 295.593 258.992 289.938 223.403C278.365 150.571 308.229 46.0935 365.806 0Z" fill="url(#popup-linear-gradient)" />
            </svg>
          </section>
        </div>
      </article>
    </Modal>
  );
};
